
export function trigger(eventType, data) {
    const event = new CustomEvent(eventType, { detail: data });
    document.dispatchEvent(event);
}

export const scrollMainOutputToTop = () => {
    trigger('mainOutput:scrollToTop')
}
